'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');
var _ = require('lodash');

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * retrieves nutrition data for products list
     * @param params
     * @returns {*}
     */
    getNutritionData: function getNutritionData(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        qs.data = JSON.stringify(params.data);
        return this.getApiRequest(this.getUrl().nutritionalData, qs);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/nutritionServiceClient.js
// module id = 774
// module chunks = 0